import { transformGamesWithJoinedOdds } from '../../services/UserGroup.js';
import { APP_CONFIG, getHeaders } from '../constants/global-variables.js';

export async function getGames(leagueId) {

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/gamesByLeague/${leagueId}`;

    try {
        const res = await axios.get(url, getHeaders());
        const dataTransformed = transformGamesWithJoinedOdds(res.data);
        return dataTransformed;
    } catch (err) {
    }
}

export async function getGamesByCountry(countryId) {

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/prematchgamesbycountry/${countryId}`;

    try {
        const res = await axios.get(url, getHeaders());
        const dataTransformed = transformGamesWithJoinedOdds(res.data);
        return dataTransformed;
    } catch (err) {
    }
}

export async function getLiveLeftPanelGames(sport_id) {

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/livegameslist/${sport_id}`;

    try {
        const res = await axios.get(url, getHeaders());
        const dataTransformed = transformGamesWithJoinedOdds(res.data);
        return dataTransformed;
    } catch (err) {
    }
}

